import { Observable } from 'rxjs/Observable';
import { CoinsProvider } from './../../providers/coins/coins';
import { ViewController, ModalController, AlertController, ToastController } from 'ionic-angular';
import { Component } from '@angular/core';
import { NavController } from '../../../node_modules/ionic-angular/navigation/nav-controller';
import { LiveSignal, PriceData } from '../../models/Signal';
import { SignalsProvider } from '../../providers/signals/signals';
import { UserProvider } from '../../providers/user/user';

/**
 * Generated class for the AddSignalComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    selector: 'add-signal-stocks',
    templateUrl: 'add-signal-stocks.html'
})
export class AddSignalStocksComponent {

    signal: LiveSignal;
    editMode: boolean = false;
    newSignal: boolean = false;

    isAdmin: Observable<boolean>;

    constructor(
        public viewCtrl: ViewController,
        public navCtrl: NavController,
        public modalCtrl: ModalController,
        public coinCtrl: CoinsProvider,
        public alertCtrl: AlertController,
        public toastCtrl: ToastController,
        public signalsCtrl: SignalsProvider,
        public userCtrl: UserProvider
    ) {
        this.isAdmin = this.userCtrl.isAdmin();

        //Set up editor if param passed in
        let signal: LiveSignal = this.viewCtrl.getNavParams().get('signal');

        if (signal) {
            this.signal = signal;
        } else { //Otherwise set up a new signal to create
            this.newSignal = true;
            this.signal = new LiveSignal(null);
            this.signal.data.isStock = true;
            this.signal.data.spot = 0; //init to sentenal
        }
    }
    addTarget() {
        if (this.editMode) return;

        let alert = this.alertCtrl.create({
            title: `Add Target for ${this.signal.data.coin}`,
            inputs: [
                {
                    name: 'target',
                    placeholder: 'Target Price in USD',
                    type: 'number'
                }
            ],
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel'
                },
                {
                    text: 'Add',
                    handler: data => {
                        const price = parseInt(data['target']);
                        this.signal.addTarget(price);
                        return true;
                    }
                }
            ]
        });
        alert.present();
    }

    removeTarget(target: PriceData) {
        this.signal.removeTarget(target);
    }

    editTarget(target: PriceData) {
        let alert = this.alertCtrl.create({
            title: `Edit Target @ ${target.price}`,
            subTitle: `You can add a time for which this target was satisfied and an optional message. You can also press 'Now' to set the current time :)`,
            inputs: [
                {
                    name: 'time',
                    placeholder: '',
                    type: 'datetime-local'
                }
            ],
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel'
                },
                {
                    text: 'Now',
                    handler: data => {
                        const time = new Date();
                        target.timestamp = time.getTime().toString();
                        this.signal.editTarget(target);
                    }
                },
                {
                    text: 'Set',
                    handler: data => {
                        let rawTime = data['time'];
                        if (rawTime) {
                            const time = new Date(rawTime);
                            target.timestamp = time.getTime().toString();
                            this.signal.editTarget(target);
                        }
                    }
                }
            ]
        });
        alert.present();
    }

    addStop() {

        let alert = this.alertCtrl.create({
            title: `Add Stop Loss for ${this.signal.data.coin}`,
            inputs: [
                {
                    name: 'stop',
                    placeholder: 'Stop Loss Price in USD',
                    type: 'number'
                }
            ],
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                },
                {
                    text: 'Add',
                    handler: data => {
                        const price = parseFloat(data['stop']);
                        this.signal.addStop(price);
                        return true;
                    }
                }
            ]
        });
        alert.present();

    }

    removeStop(stop: PriceData) {
        this.signal.removeStop(stop);
    }

    editStop(stop: PriceData) {
        let alert = this.alertCtrl.create({
            title: `Edit Stop @ ${stop.price}`,
            subTitle: `You can add a time for which this stop loss was satisfied.`,
            inputs: [
                {
                    name: 'time',
                    placeholder: '',
                    type: 'datetime-local'
                }
            ],
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel'
                },
                {
                    text: 'Set',
                    handler: data => {
                        let rawTime = data['time'];
                        if (rawTime) {
                            const time = new Date(rawTime);
                            stop.timestamp = time.getTime().toString();
                            this.signal.editStop(stop);
                        }
                    }
                }
            ]
        });
        alert.present();
    }

    saveSignal() {
        const alert = this.alertCtrl.create({
            title: `Save Signal`,
            subTitle: `Are you sure you want to save this signal?`,
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel'
                },
                {
                    text: 'Yes',
                    handler: data => {
                        this.signalsCtrl.editSignal(this.signal).then(val => {
                            this.toastCtrl.create({ message: 'Signal Saved', duration: 2000 }).present();
                            this.dismiss();
                        });
                    }
                }
            ]
        })
        alert.present();
    }

    closeSignal() {
        this.alertCtrl.create({
            title: `Close Signal`,
            subTitle: `Are you sure you want to close this signal? Add a close price here or leave it blank if you want to use the most recent target/stop.`,
            inputs: [
                {
                    name: 'closePrice',
                    placeholder: 'Close Price',
                    type: 'number'
                }
            ],
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel'
                },
                {
                    text: 'OK',
                    handler: data => {
                        let price = parseInt(data.closePrice);

                        if (price) {
                            this.signal.setClosePrice(price);
                        } else {
                            if (!this.signal.getLatestPrice()) {
                                alert(`You need to input a close price because you didn't hit any targets/stops`);
                                return;
                            }
                            this.signal.setClosePrice(this.signal.getLatestPrice().price);
                        }
                        this.signal.data.isActive = false;

                        const latestPrice = this.signal.getLatestPrice().price.toLocaleString();
                        const percentGain = this.signal.getCurrentPercentGain().toFixed(2);

                        this.alertCtrl.create({
                            title: `Is this right?`,
                            subTitle: `
                                Are you sure you want to close this signal at:
                                ${latestPrice} Satoshis 
                                ${percentGain}%
                            `,
                            buttons: [
                                {
                                    text: 'No',
                                    handler: data => {
                                        this.signal.data.close = null;
                                        this.signal.data.isActive = true;
                                        this.signal.latestPrice = this.signal.getLatestPrice();
                                    }
                                },
                                {
                                    text: 'Yes',
                                    handler: data => {
                                        this.signalsCtrl.editSignal(this.signal).then(val => {
                                            this.toastCtrl.create({ message: 'Signal Closed', duration: 2000 }).present();
                                            this.dismiss();
                                        });
                                    }
                                }
                            ]
                        }).present()

                    }
                }
            ]
        }).present();
    }

    removeSignal() {
        const alert = this.alertCtrl.create({
            title: `Delete Signal`,
            subTitle: `Are you sure you want to delete this signal? You really shouldn't do this unless you've made a mistake.`,
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel'
                },
                {
                    text: 'Yes',
                    handler: data => {
                        this.signalsCtrl.removeSignal(this.signal).then(val => {
                            this.toastCtrl.create({ message: 'Signal Deleted', duration: 2000 }).present();
                            this.dismiss();
                        });
                    }
                }
            ]
        })
        alert.present();
    }

    publishSignal() {
        const alert = this.alertCtrl.create({
            title: `Publish Signal`,
            subTitle: `Are you sure you are ready to publish this signal? Might wanna double check.`,
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel'
                },
                {
                    text: 'Yes',
                    handler: data => {
                        this.signal.data.timestamp = (new Date()).getTime().toString();
                        this.signalsCtrl.addSignal(this.signal).then(val => {
                            this.toastCtrl.create({ message: 'Signal Published', duration: 2000 }).present();
                        });
                        this.dismiss();
                    }
                }
            ]
        })
        alert.present();
    }


    getGainClass(): string {
        let gain = this.signal.getCurrentPercentGain();
        if (gain > 0) {
            return 'target';
        } else if (gain < 0) {
            return 'stop';
        } else {
            return '';
        }
    }

    dismiss() {
        this.viewCtrl.dismiss();
    }

}



// WEBPACK FOOTER //
// ./src/components/add-signal-stocks/add-signal-stocks.ts